import { Fill } from "./PrivacyPolicyUI";

export const PrivacyPolicyFooter = () => {
  return (
    <footer className="mx-auto flex max-w-[1080px] flex-wrap gap-3 px-7 pb-8 text-[12.5px] text-[#6b7aab]">
      <span>
        © 2026 <Fill>Jai Bharat Construction Company</Fill>
      </span>

      <span className="ml-auto max-[640px]:ml-0">
        <a
          href="mailto:privacy@example.com"
          className="border-b border-[#2e45a8]/30 text-[#2e45a8] no-underline"
        >
          privacy@example.com
        </a>
      </span>

      <span>v1.0 · 7 Aug 2026</span>
    </footer>
  );
};
